<template>
    <div class="px-6 surface-overlay relative">
        <div class="py-3 lg:py-3 px-6 flex align-items-center justify-content-between lg:static">
            <img src="images/blocks/logos/kitrin-logo-black-revised-software-rev2.png" alt="IsoEvolve" height="50"
                 class="mr-0 lg:mr-6">
            <div class="flex align-items-center">
                <a v-ripple class="cursor-pointer block lg:hidden text-700 mr-5 p-ripple"
                   v-styleclass="{ selector: '#navbar-sub-7', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-ellipsis-v text-2xl"></i>
                </a>
                <a v-ripple class="cursor-pointer block lg:hidden text-700 p-ripple"
                   v-styleclass="{ selector: '#navbar-7', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-bars text-4xl"></i>
                </a>
            </div>
            <div id="navbar-sub-7"
                 class="hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1 shadow-2 lg:shadow-none">
                <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none">
                    <li>
                        <a @click="handleHome" v-tooltip="'Home'" v-ripple
                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-home text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Home</span>
                        </a>
                    </li>
                    <li>
                        <a @click="handleRegister" v-tooltip="'Signup for Account'" v-ripple
                           class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-user text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Signup for Account</span>
                        </a>
                    </li>

                </ul>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    methods: {
        handleHome() {
            console.log("[IsoEvolveLoginMenu][handleHome] Start of function. Redirecting to functionality.");
            window.location.href = "https://kitrin.com";
        },
        handleRegister() {
            console.log("[Login][IsoEvolveLoginMenu] Start of function. Redirecting to functionality.");
            this.$router.push("register");
        },

    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
